import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import DeleteModal from '../../../Components/Common/DeleteModal';
import { createSelector } from 'reselect';
import { toggleDeleteUserModal } from '../../../slices/modals/reducer';
import { removeUser } from '../../../slices/auth/settings/thunk';

/**
 * React component for rendering a modal to confirm and handle the deletion of a user.
 * @component
 */
function DeleteUserModal() {
  const dispatch = useDispatch();

  const selectDeleteUserModal = createSelector((state) => state, (state) => ({
    deleteModal: state.Modal.deleteUserModal,
    selectedUserId: state.Settings.selectedUserId
  }));
  const { deleteModal, selectedUserId } = useSelector(selectDeleteUserModal);

  /**
   * Dispatches an action to remove a user.
   */
  async function deleteUser() {
    await dispatch(removeUser(selectedUserId));
    dispatch(toggleDeleteUserModal());
  }
  return (
    <DeleteModal
      show={deleteModal}
      onCloseClick={() => dispatch(toggleDeleteUserModal())}
      onDeleteClick={deleteUser}
    />
  )
}

export default DeleteUserModal;